import Excel from "exceljs";
import { saveAs } from "file-saver";

import templateUrl from "../../../assets/templates/SPPO-P2P-invoice-distribution-template.xlsx";
import { toChinaDateString } from "../../../lib/chinaDate";
import { bolNumberForItem } from "../shippings/saveShippingList";


const TEMPLATE_DATA_ROW = 2;

function distributionBolNumber(shipping) {
  const number = shipping?.number;
  if (!number) return "";
  if (/^SHJH/i.test(number) && shipping?.itemNumber != null && shipping.itemNumber !== "") {
    return bolNumberForItem(number, shipping.itemNumber);
  }
  return number;
}

export default async function onGenerateCombinedDistributionTable({
  selectionModel,
}) {
  if (!selectionModel?.length) return;

  const response = await fetch(templateUrl);
  const arrayBuffer = await response.arrayBuffer();

  const workbook = new Excel.Workbook();
  await workbook.xlsx.load(arrayBuffer);

  const sheet = workbook.worksheets[0];

  // The template pre-formats a block of data rows (borders/font already
  // applied down to row 23, with rows 2-3 holding sample values). Overwrite
  // cell values/styles directly instead of splicing/appending rows, since
  // exceljs' spliceRows does not reliably remove large row ranges.
  const cellStyles = [];
  sheet.getRow(TEMPLATE_DATA_ROW).eachCell({ includeEmpty: true }, (cell, col) => {
    cellStyles[col] = {
      font: cell.font,
      border: cell.border,
      fill: cell.fill,
      alignment: cell.alignment,
      numFmt: cell.numFmt,
    };
  });

  selectionModel.forEach((x, i) => {
    const sapBox = x.po?.number?.split("-")?.[0] || "";
    const poNo = x.po?.number?.split("-")?.[1] || "";
    const poLineItem = x.po?.itemNumber || "";

    const rowValues = [
      sapBox,
      poNo ? Number(poNo) || poNo : "",
      poLineItem ? Number(poLineItem) || poLineItem : "",
      distributionBolNumber(x.shipping),
      null,
      x.number,
      x.qty,
      x.amount,
    ];

    const row = sheet.getRow(TEMPLATE_DATA_ROW + i);
    rowValues.forEach((value, idx) => {
      const col = idx + 1;
      const cell = row.getCell(col);
      cell.value = value;

      const style = cellStyles[col];
      if (style) {
        cell.font = style.font;
        cell.border = style.border;
        cell.fill = style.fill;
        cell.alignment = style.alignment;
        if (style.numFmt) cell.numFmt = style.numFmt;
      }
    });
    row.commit();
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const date = toChinaDateString();
  saveAs(blob, `SPPO-P2P-发票分配表-${date}.xlsx`);
}
